import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
    selector: 'app-modal',
    templateUrl: './modal.component.html',
    standalone: false,
})
export class ModalComponent implements OnInit {
    // @ts-ignore TS2564
    title: string;
    // @ts-ignore TS2564
    closeBtnName: string;
    list: any[] = [];

    constructor(public bsModalRef: BsModalRef) {}

    ngOnInit() {
        this.list.push('PROFIT!!!');
    }
}
